module.exports = __webpack_public_path__ + "img/bg-lg-eng-01.1f4afbc7.jpg";